import { useState } from "react";
import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Container,
  IconButton,
  Collapse,
  Divider,
  Switch,
  Tooltip,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import PrintIcon from "@mui/icons-material/Print";

import { useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

const columns = [
  { id: "bin", label: "Bin location" },
  { id: "item_code", label: "Item code" },
  { id: "name", label: "Name" },
  { id: "unit_quantity", label: "Unit" },
  { id: "case_quantity", label: "Case" },
  { id: "price_per_type", label: "Pricing" },
  { id: "combined_stock_level", label: "Combined stock" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  customTable: {
    "& .MuiTableCell-sizeSmall": {
      padding: "6px 0px 6px 8px",
    },
  },
}));

const Print = (props) => {
  const classes = useStyles();
  const location = useLocation();

  const { customer, order, orderItems } = location.state;

  const currentUserStore = useSelector((state) => state.current_user);

  const cDate = new Date();
  let eDate = new Date();
  eDate.setDate(eDate.getDate() + 1);

  const [displayDetails, setDisplayDetails] = useState(false);

  const toggleDisplayDetails = () => setDisplayDetails(!displayDetails);

  const handleBack = () => {
    if (props.location.hasOwnProperty("search")) {
      const orderId = order.id;
      if (props.location.search.includes("order") && orderId) {
        props.history.push(`/order/${orderId}`);
      } else {
        props.history.push(`/orders`);
      }
    } else {
      props.history.push("/orders");
    }
  };

  return (
    <>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={true} sm={true}>
                <Typography variant="h6" component="div">
                  {`Order ${order.id}`}
                </Typography>
              </Grid>
              <Grid item xs="auto" sm="auto">
                <IconButton
                  variant="contained"
                  onClick={handleBack}
                  title="Back"
                >
                  <PrintIcon color="info" />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider textAlign="right">
              <Tooltip title={`${displayDetails ? "Show" : "Hide"} details`}>
                <Switch
                  checked={!displayDetails}
                  onChange={() => toggleDisplayDetails()}
                />
              </Tooltip>
            </Divider>
            <Typography variant="subtitle1">
              <strong>Customer: </strong>
              {customer.hasOwnProperty("username")
                ? customer.username
                : "Anonymous"}
            </Typography>
            <Collapse in={!displayDetails}>
              <Typography variant="subtitle1">
                <strong>Status: </strong>
                {order.hasOwnProperty("status")
                  ? order.status_label
                  : "Submitted"}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Placed: </strong>
                {order.hasOwnProperty("created_date")
                  ? order.created_date.split("T")[0]
                  : cDate.toISOString().split("T")[0]}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Estimated Delivery: </strong>
                {order.hasOwnProperty("delivery_date")
                  ? order.delivery_date.split("T")[0]
                  : eDate.toISOString().split("T")[0]}
              </Typography>
            </Collapse>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            {currentUserStore ? (
              <TableContainer>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  size="small"
                  classes={{ root: classes.customTable }}
                >
                  <TableHead>
                    <TableRow>
                      {columns
                        .filter((column) => {
                          let visible = true;

                          if (column.hasOwnProperty("visibility_deny_rid")) {
                            visible = !column.visibility_deny_rid.includes(
                              currentUserStore.role_id
                            );
                          }

                          if (column.hasOwnProperty("visibility_allow_rid")) {
                            visible = column.visibility_allow_rid.includes(
                              currentUserStore.role_id
                            );
                          }

                          return visible;
                        })
                        .map((column) => (
                          <TableCell
                            key={`header-${column.id}`}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderItems.length &&
                      orderItems.map((row, index) => (
                        <TableRow hover tabIndex={-1} key={`row-${index}`}>
                          {columns
                            .filter((column) => {
                              let visible = true;

                              if (
                                column.hasOwnProperty("visibility_deny_rid")
                              ) {
                                visible = !column.visibility_deny_rid.includes(
                                  currentUserStore.role_id
                                );
                              }

                              if (
                                column.hasOwnProperty("visibility_allow_rid")
                              ) {
                                visible = column.visibility_allow_rid.includes(
                                  currentUserStore.role_id
                                );
                              }

                              return visible;
                            })
                            .map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={`column-${column.id}-row-${index}`}
                                  style={{
                                    maxWidth:
                                      column.id === "name" ? 350 : "auto",
                                  }}
                                >
                                  {typeof value === "boolean" ? (
                                    "" + value
                                  ) : typeof value === "object" ? (
                                    value === null ? (
                                      "N/A"
                                    ) : value[column.id] ? (
                                      ["item_code", "item_codee"].includes(
                                        column.id
                                      ) && row.weight_type === "r/w" ? (
                                        <b>{value[column.id]}</b>
                                      ) : (
                                        value[column.id]
                                      )
                                    ) : (
                                      "N/A"
                                    )
                                  ) : column.id === "price_per_type" ? (
                                    <>
                                      {row.unit_quantity > 0 ? (
                                        <>U: {`$${row.price_per_unit}`}</>
                                      ) : (
                                        <></>
                                      )}
                                      {row.unit_quantity > 0 &&
                                      row.case_quantity > 0 ? (
                                        <br />
                                      ) : (
                                        <></>
                                      )}
                                      {row.case_quantity > 0 ? (
                                        <>C: {`$${row.price_per_case}`}</>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : column.id.includes("price") ? (
                                    "$" + value
                                  ) : column.id.includes("quantity") ? (
                                    (column.id.includes("unit")
                                      ? "U: "
                                      : "C: ") + value
                                  ) : column.id === "name" &&
                                    row.weight_type === "r/w" ? (
                                    <b>{value}</b>
                                  ) : (
                                    value || 0
                                  )}
                                </TableCell>
                              );
                            })}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Print;
